import { computed, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { HttpClient } from '@angular/common/http';
import { distinctUntilChanged, interval, map, shareReplay, switchMap } from 'rxjs';
import { environment } from '../../environments/environment';
import dayjs from 'dayjs';

@Injectable({ providedIn: 'root' })
export class ServerTimeService {
  private readonly apiUrl = environment.apiUrl;
  private readonly http = inject(HttpClient);

  private readonly serverInfo$ = this.http
    .get<{ serverUtcTime: string; serverTimeZone: string }>(`${this.apiUrl}/server-time`)
    .pipe(
      map(r => ({
        zone: r.serverTimeZone,
        // szerver UTC idő és a monoton óra különbsége
        offset: dayjs.utc(r.serverUtcTime).valueOf() - performance.now(),
      })),
      shareReplay(1),
    );

  private readonly info = toSignal(this.serverInfo$);

  private readonly utcTimeStream$ = this.serverInfo$.pipe(
    switchMap(({ offset }) =>
      interval(250).pipe(
        // másodpercre csonkolt UTC ISO string, pl. 2026-10-18T09:15:42.000Z
        map(() =>
          dayjs
            .utc(performance.now() + offset)
            .startOf('second')
            .toISOString(),
        ),
        distinctUntilChanged(),
      ),
    ),
  );

  /** Szerver UTC idő ISO stringként. Megjelenítéshez zónára kell alakítani. */
  readonly serverUtcTime = toSignal(this.utcTimeStream$, { initialValue: '' });
  readonly serverTimeZone = computed(() => this.info()?.zone ?? 'UTC');
}
